import React from 'react';
import { formatDateTime } from './formatting';

import styles from './data_refresh_bar.module.css';

// The refresh cadence differs per page, and safety data is refreshed more often than the rest of
// the clinical dashboard, so the page says which cadence applies to what is on screen.
export default function DataRefreshBar({ dataRefresh }) {
  if (!dataRefresh) {
    return null;
  }

  return (
    <div className={styles.bar}>
      <span className={styles.cadence}>Client Data Refresh: {dataRefresh.cadence}</span>
      <span className={styles.detail}>Last refreshed {formatDateTime(dataRefresh.last_refreshed_at)}</span>
      <span className={styles.detail}>
        Values as of {formatDateTime(dataRefresh.as_of_utc, { timeZone: 'UTC' })} UTC
      </span>
    </div>
  );
}
